import React, { Component } from "react";
import { Popconfirm, notification } from "antd";
import { gql } from "apollo-boost";
import { Mutation } from "@apollo/react-components";
import { LIST_SELLER_PRODUCTS_QUERY } from "../../pages/seller/Products";

const DELETE_TAGS = gql`
  mutation addTagsToProducts($productIds: [ID!]!, $add: Boolean!) {
    addTagsToProducts(productIds: $productIds, add: $add)
  }
`;
class DeleteTagsProducts extends Component {
  state = {
    loading: false,
  };
  render() {
    const { selectedRows, onPopOverClose } = this.props;
    return (
      <Mutation
        mutation={DELETE_TAGS}
        onCompleted={(res) => {
          this.setState({ loading: false }, () =>
            notification.success({ message: "Delete tags success!" })
          );
        }}
        onError={(err) => {
          notification.error({ message: err.toString() });
        }}
      >
        {(addTagsToProducts, { client }) => (
          <Popconfirm
            title="Are you sure to delete tags?"
            okText="Yes"
            cancelText="No"
            onCancel={onPopOverClose}
            placement="right"
            onConfirm={() => {
              addTagsToProducts({
                variables: {
                  productIds: selectedRows,
                  add: false,
                },
              }).then((res) => {
                this.setState({ loading: false });
                try {
                  const { filter } = this.props;
                  const variables = {
                    filter: filter,
                  };
                  const cache = client.readQuery({
                    query: LIST_SELLER_PRODUCTS_QUERY,
                    variables,
                  });
                  client.writeQuery({
                    query: LIST_SELLER_PRODUCTS_QUERY,
                    variables,
                    data: {
                      ...cache,
                      products: {
                        ...cache.products,
                        nodes: [
                          ...cache.products.nodes.map(
                            (product) => (
                              selectedRows.find((s) => s === product.id)
                                ? (product.tags = null)
                                : null,
                              product
                            )
                          ),
                        ],
                      },
                    },
                  });
                } catch (e) {}
              });
              onPopOverClose();
            }}
          >
            <div style={{ cursor: "pointer" }}>Remove Tags</div>
          </Popconfirm>
        )}
      </Mutation>
    );
  }
}

export default DeleteTagsProducts;
